import { z } from 'zod';

export const categoryZod = z.object({
  token: z.string(),
  name: z.string(),
  displayName: z.string(),
  comments: z.nullable(z.string()),
  description: z.nullable(z.string()),
  color: z.nullable(z.string()),
  tag: z.nullable(z.string()),
  mmdbCategoryId: z.nullable(z.number().int().nonnegative()),
  semSegId: z.nullable(z.number().int().min(0).max(255)),
});

export const categoriesZod = z.array(categoryZod).transform((categories) => {
  return categories.sort((a, b) => a.displayName.localeCompare(b.displayName));
});

export type Category = z.infer<typeof categoryZod>;
export type SemSegCategory = Category & { semSegId: number };
export type CategoriesResp = z.infer<typeof categoriesZod>;
